exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".rocky-img[data-v-11f1319e] {\n  max-width: 120px;\n  height: auto;\n}\n.rocky-card[data-v-11f1319e]:hover {\n  cursor: pointer;\n}\n.rocky-list[data-v-11f1319e] {\n  max-width: 720px;\n}\n#title[data-v-11f1319e] {\n  padding-top: 2rem;\n}\n", ""]);
